import { useContext } from 'react';
import { Badge, IconButton, Stack, Toolbar } from '@mui/material';
import { CalendarMonth, ShoppingCart } from '@mui/icons-material';
import ChefControl from '../../Chef/Control/ChefControl';
import './Header.css';
import { Link } from 'react-router-dom';
import AuthContext from '../../../context/auth-context';
import MealPlansContext from '../../../context/meal-plans-context';
import ShoppingListContext from '../../../context/shopping-list-context';

const Header = () => {
  const { loggedUser } = useContext(AuthContext);
  const { plans, activePlanCount } = useContext(MealPlansContext);
  const { itemCount } = useContext(ShoppingListContext);

  const hasOverduePlan = plans.some((p) => p.status === 'active' && p.dueDate !== null && p.dueDate < new Date());

  return (
    <Toolbar className="header-toolbar" sx={{ borderBottom: 1, borderColor: 'divider' }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Link to="/" className="header-home-link">
          <img src="/make-my-menu.png" alt="MakeMyMenu" className="header-logo" />
        </Link>
        <Stack direction="row" alignItems="center" spacing={1}>
          {loggedUser && (
            <>
              <IconButton component={Link} to="/meal-plans" size="small">
                <Badge badgeContent={activePlanCount} color={hasOverduePlan ? 'error' : 'primary'}>
                  <CalendarMonth />
                </Badge>
              </IconButton>
              <IconButton component={Link} to="/shopping-list" size="small">
                <Badge badgeContent={itemCount} color="primary">
                  <ShoppingCart />
                </Badge>
              </IconButton>
            </>
          )}
          <ChefControl />
        </Stack>
      </Stack>
    </Toolbar>
  );
};

export default Header;
